/* src/app/system-view/main-dashboard/mini-card/mini-card.component.scss */
:host {
  display: block;
  height: 100%;
}
.mc-shell {
  --mc-bg: var(--tem-surface-2);
  --mc-fg: var(--tem-ink);
  --mc-icon: var(--tem-deep);
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  min-height: 0;
  border-radius: var(--tem-radius);
  border: 1px solid var(--tem-border);
  box-shadow: var(--tem-shadow);
  background: var(--tem-surface);
  overflow: hidden;
  transition: border-color 0.2s ease;
}
.mc-shell:hover {
  border-color: var(--tem-deep);
}
.mc-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--tem-space-2);
  padding: var(--tem-space-1) var(--tem-space-1) var(--tem-space-1) var(--tem-space-3);
  border-bottom: 1px solid var(--tem-border);
  flex-shrink: 0;
  background: var(--tem-surface-2);
  max-height: 40px;
}
.mc-title-group {
  display: flex;
  align-items: center;
  gap: var(--tem-space-2);
  min-width: 0;
}
.mc-title-icon {
  color: var(--mc-icon);
  display: flex;
  flex-shrink: 0;
}
.mc-title {
  font-size: var(--tem-fs-md);
  font-weight: 600;
  color: var(--tem-ink);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.mc-menu-icon {
  margin-right: var(--tem-space-2);
}
.mc-spin {
  flex: 1 1 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
.mc-spin ::ng-deep .ant-spin-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.mc-body {
  flex: 1 1 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: var(--tem-space-3);
  padding: var(--tem-space-4);
  background:
    linear-gradient(
      180deg,
      var(--mc-bg) 10%,
      var(--tem-surface) 100%);
  color: var(--mc-fg);
}
.mc-content {
  display: flex;
  align-items: center;
  justify-content: center;
}
.mc-value {
  margin: 0;
  color: var(--mc-fg);
  font-size: clamp(1.2rem, 2.1vw, 2rem);
  font-weight: 700;
  letter-spacing: 0.01em;
  text-align: center;
}
.mc-metrics {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--tem-space-2);
}
.mc-delta {
  display: inline-flex;
  align-items: center;
  gap: var(--tem-space-1);
  font-weight: 600;
  font-size: var(--tem-fs-sm);
  border-radius: 999px;
  padding: 2px var(--tem-space-2);
}
.mc-delta.up {
  color: var(--tem-success);
  background: color-mix(in srgb, var(--tem-success) 12%, transparent);
}
.mc-delta.down {
  color: var(--tem-danger);
  background: color-mix(in srgb, var(--tem-danger) 12%, transparent);
}
.mc-duration {
  font-size: var(--tem-fs-sm);
  color: var(--tem-muted);
  white-space: nowrap;
}
.mc-footer {
  display: flex;
  align-items: center;
  padding: var(--tem-space-1) var(--tem-space-3);
  border-top: 1px solid var(--tem-border);
  flex-shrink: 0;
  background: var(--tem-surface);
}
.mc-last-update {
  display: inline-flex;
  align-items: center;
  gap: var(--tem-space-1);
  font-size: var(--tem-fs-sm);
  font-weight: 500;
  color: var(--tem-warn);
  background: color-mix(in srgb, var(--tem-warn) 10%, transparent);
  border-radius: 20px;
  padding: 2px var(--tem-space-2);
  white-space: nowrap;
}
.mc-last-update-icon {
  font-size: var(--tem-fs-sm);
}
/*# sourceMappingURL=mini-card.component.css.map */
